import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from 'src/app/core/services/core.service';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'bs-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public profile: any;
  public carouselData: any = {items: []};

  constructor(
    private http: HttpClient,
    public coreService: CoreService,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
  ) { }

  ngOnInit() {
      this.route.params.subscribe(
        params => {
          this.coreService
          .fetchData('profiles/' + this.route.snapshot.params['id'])
          .subscribe((results: any) => {
            if (results.backgroundImage && results.backgroundImage.data) {
              this.carouselData.items = [{
                image: this.coreService.getCompressedImage(results.backgroundImage.data.url)
              }];
            }
            if (results.biography) {
              results.biography = this.coreService.generateBody(results.biography);
            }
            this.profile = results;

            ['og:image', 'twitter:image'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: this.coreService.getCompressedImage(results.image.data.url)
            }));
            this.titleService.setTitle(`${results.name} - British Shooting`);
            ['og:title', 'twitter:title'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: `${results.name} - British Shooting`
            }));
            ['description', 'og:description', 'twitter:description'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: results.description
                ? results.description
                : results.biography
                    .replace(/<\/?[^>]+(>|$)/g, '')
                    .substring(0, 160)
                    .replace(/(^|\s)\S*$/, '')
                    .trim(),
            }));
          });
        }
      );
  }

}
